import { FormSection } from 'framework/ui/layout';
import { useMemo } from 'react';
import { useDateService, DATE_FORMAT } from 'framework/utils';
import { DateInput, TextInput, ModalFormButton } from 'framework/form';
import { Typography } from '@mui/material';
import moment from 'moment/moment';
import { useShowContext } from 'framework/show';
import useKPIService, { KPI_TYPES_UNIT_OPTIONS, PublishValueType } from '../../useKPIService';
import { useAuthorization } from 'framework/authorization';

type PublishKpiValueButtonProps = {
  effectiveDate: string;
  currentFilterValue: string;
  permissionToCheck: string;
  kpiStructureId: string;
  parenListReload: () => void;
};

const PublishKpiValueButton = ({
  kpiStructureId,
  effectiveDate,
  currentFilterValue,
  permissionToCheck,
  parenListReload,
}: PublishKpiValueButtonProps) => {
  const { data } = useShowContext();
  const { id: kpiParameterId, name, type, value } = data.getData();
  const formatType = KPI_TYPES_UNIT_OPTIONS[type];
  const { formatDate } = useDateService();
  const currentDate = moment();
  const minDate = useMemo(() => formatDate(effectiveDate, DATE_FORMAT.API_ONLY_DATE), [effectiveDate, formatDate])!;
  const maxDate = useMemo(() => formatDate(currentDate, DATE_FORMAT.API_ONLY_DATE), [currentDate, formatDate])!;
  const { isGranted } = useAuthorization();
  const { publishKPIParams, getPublishValidationSchema } = useKPIService();

  return isGranted(permissionToCheck) ? (
    <>
      <ModalFormButton
        outline
        isVisible={isGranted(permissionToCheck)}
        disabled={value !== null}
        formTitle="Publish"
        label="Publish"
        submitFormFunc={formState =>
          publishKPIParams({
            ...formState,
            kpiStructureId,
            kpiParameterId,
          } as PublishValueType)
        }
        afterSubmit={{
          execute: () => {
            parenListReload();
          },
        }}
        initialData={{
          period: currentFilterValue,
        }}
        getValidationSchemaFunc={getPublishValidationSchema}
      >
        <FormSection>
          <Typography mb={1.25}>
            Effective Date - {effectiveDate}. Publish parameter - {name} ({formatType}).
          </Typography>
          <DateInput
            minDate={minDate}
            maxDate={maxDate}
            dateFormat={DATE_FORMAT.API_ONLY_MONTH}
            source="period"
            label="Period"
          />
          <TextInput label={`Value (${formatType})`} source="value" />
        </FormSection>
      </ModalFormButton>
    </>
  ) : (
    <></>
  );
};

export default PublishKpiValueButton;
